import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import DeepDiveSection from './components/DeepDiveSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '吃瓜爆料网',
    url: 'https://chigua.baoliao.wang',
    description: '吃瓜爆料网实时同步吃瓜爆料网站入口与吃瓜爆料网51最新地址，明星塌房现场、网红黑料翻车视频每日速递，一手八卦情报随时点开就吃。',
    inLanguage: 'zh-CN',
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '吃瓜爆料网',
    url: 'https://chigua.baoliao.wang',
    description: '中国领先的娱乐八卦资讯平台',
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrendingSection />
        <DeepDiveSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}